<template>
  <v-container fluid>

    <v-row>
      <v-col>
        <div class='d-flex align-items-center'>
          <div>
            <h3>Orders filter</h3>
          </div>
          <div class='ml-auto d-flex align-items-center'>
            <v-text-field append-icon="mdi-magnify" label="Search order references" hide-details
              v-model='local_q'
              @keyup.enter='apply_filter'>
            </v-text-field>
            <button type='button' @click='apply_filter' class='btn btn-primary text-white ml-4'>Filter</button>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols=2>
        <v-select v-model='local_type' label='Order type' chips multiple :items="type_options"></v-select>
      </v-col>
      <v-col cols=2>
        <v-select v-model='local_suppliers' label='Branch' chips multiple :items="suppliers_options"></v-select>
      </v-col>
      <v-col cols=2>
        <v-select v-model='local_status' label='Status' chips multiple :items="status_options"></v-select>
      </v-col>
      <v-col cols=2 class='d-flex align-items-end'>
        <v-text-field prefix='R' v-model='local_total_min' type='number' class='text-right' label='Total min' ></v-text-field>
      </v-col>
      <v-col cols=2 class='d-flex align-items-end'>
        <v-text-field prefix='R' v-model='local_total_max' type='number' class='text-right' label='Total max' ></v-text-field>
      </v-col>
      <v-col cols=2 class='d-flex align-items-end'>
        <v-menu offset-y min-width="auto" transition="scale-transition" :nudge-right="40" :close-on-content-click="false"
          v-model="date_menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field readonly label="Daterange" prepend-icon="mdi-calendar"
              :value="daterange_display"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker range no-title v-model='local_daterange' @change='date_menu = false' >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="clear_date_filter"> Reset </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  data() {
    return {
      type_options: ['retail', 'stokvel', 'collection', 'delivery'],
      date_menu: false,
      local_q: '',
      local_type: [],
      local_suppliers: [],
      local_status: [],
      local_total_min: '',
      local_total_max: '',
      local_daterange: []
    }
  },

  created() {
    this.$store.dispatch('orders/fetch_shipping_statuses')
    this.read_filter_from_url()
  },

  computed: {
    status_options() {
      return this.$store.state.orders.shipping_statuses
    },
    suppliers_options() {
      return this.$store.getters['suppliers/as_select_options']
    },
    daterange_display() {
      return this.local_daterange.join(' ~ ')
    }
  },

  watch: {
    '$route.query'() {
      this.read_filter_from_url()
    }
  },

  methods: {
    parse_array(val) {
      if (!val) return []
      return Array.isArray(val) ? val : val.split(',').filter(v => v)
    },

    read_filter_from_url() {
      const query = this.$route.query
      this.local_q = query.q || ''
      this.local_type = this.parse_array(query.type)
      this.local_suppliers = this.parse_array(query.suppliers)
      this.local_status = this.parse_array(query.status)
      this.local_total_min = query.total_min || ''
      this.local_total_max = query.total_max || ''
      const from = query.from
      const to = query.to
      this.local_daterange = from && to ? [from, to] : from ? [from] : []
    },

    apply_filter() {
      const query = {}

      if (this.local_q) query.q = this.local_q
      if (this.local_type.length) query.type = this.local_type.join(',')
      if (this.local_suppliers.length) query.suppliers = this.local_suppliers.join(',')
      if (this.local_status.length) query.status = this.local_status.join(',')
      if (this.local_total_min && this.local_total_min !== '0') query.total_min = this.local_total_min
      if (this.local_total_max && this.local_total_max !== '0') query.total_max = this.local_total_max

      if (this.local_daterange.length) {
        const sorted = [...this.local_daterange].sort((a, b) =>
          DateTime.fromISO(a).toString() < DateTime.fromISO(b).toString() ? -1 : 1
        )
        if (sorted[0]) query.from = sorted[0]
        if (sorted[1]) query.to = sorted[1]
      }

      this.$router.replace({ query }).catch(() => {})
    },

    clear_date_filter() {
      this.local_daterange = []
      this.date_menu = false
    }
  }
}
</script>

<style>
input[type="number"] {
  text-align: right;
}
</style>
